<template>
  <v-app-bar
    class="header-app-bar"
    :class="{ home: $route.path === '/' }"
    color="transparent"
    :absolute="$route.path === '/'"
    height="120px"
    flat
  >
    <v-sheet
      class="
        d-flex
        justify-space-between
        align-center
        mx-auto
        position-relative
        header
      "
      color="transparent"
      max-width="1200px"
      width="100%"
      height="100%"
    >
      <router-link to="/">
        <img
          v-if="informations.img"
          :src="files + informations.img"
          :alt="informations.name"
          class="d-block"
          height="70px"
        />
      </router-link>

      <div class="d-flex flex-column align-end">
        <div class="d-flex">
          <div class="d-flex align-center">
            <v-btn
              href="https://sagierp.com.br/new_sagi/integra/portal/aplicacao/index.php"
              target="_blank"
              text
              class="text-none rounded-0"
            >
              <v-icon
                :color="$route.path === '/' ? 'white' : 'primary'"
                size="14"
                >fas fa-users</v-icon
              >
              <span
                class="text-caption font-weight-bold ml-1"
                :class="[$route.path === '/' ? 'white--text' : 'primary--text']"
              >
                Portal do Fornecedor
              </span>
            </v-btn>

            <v-menu offset-y transition="scroll-y-transition" tile>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  class="text-none rounded-0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon
                    :color="$route.path === '/' ? 'white' : 'primary'"
                    size="14"
                    >fas fa-user</v-icon
                  >
                  <span
                    class="text-caption font-weight-bold ml-1"
                    :class="[
                      $route.path === '/' ? 'white--text' : 'primary--text',
                    ]"
                  >
                    Portal do Cliente
                  </span>
                </v-btn>
              </template>

              <v-list class="py-0">
                <v-list-item
                  target="_blank"
                  href="https://sagierp.com.br/new_sagi/integra/portal_sagi/aplicacao/index.php"
                >
                  <v-list-item-title>Resíduos Recicláveis</v-list-item-title>
                </v-list-item>
                <v-list-item
                  target="_blank"
                  href="https://portal.canaanorte.sisgr.com/auth/login"
                >
                  <v-list-item-title>Gerenciador de Resíduos</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <v-btn
            v-if="informations.google_maps"
            color="transparent"
            :href="informations.google_maps"
            target="_blank"
            title="Google Maps"
            width="40px"
            height="40px"
            depressed
            fab
          >
            <v-icon
              :color="$route.path === '/' ? 'white' : 'primary'"
              size="20"
            >
              fa-map-marker-alt
            </v-icon>
          </v-btn>

          <template v-for="({ text, link, icon, size }, keySocial) in social">
            <v-btn
              :key="keySocial"
              color="transparent"
              :href="link"
              target="_blank"
              :title="text"
              width="40px"
              height="40px"
              depressed
              fab
            >
              <v-icon
                :color="$route.path === '/' ? 'white' : 'primary'"
                :size="size"
              >
                {{ icon }}
              </v-icon>
            </v-btn>
          </template>
        </div>

        <div class="d-flex align-center mt-2">
          <div>
            <div
              v-for="({ text, to, dropdown, blank }, keyMenu) in menu"
              :key="keyMenu"
              class="d-inline-flex"
            >
              <v-btn
                v-if="!dropdown"
                class="
                  text-caption text-lg-body-1 text-none
                  font-weight-medium
                  px-2 px-lg-3
                  py-5
                  mx-md-1
                  nav-link
                "
                :class="[$route.path === '/' ? 'white--text' : 'primary--text']"
                :to="to"
                :target="blank ? '_blank' : '_self'"
                active-class="nav-link-active"
                tile
                depressed
                text
              >
                {{ text }}
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="
                      white--text
                      text-caption text-lg-body-1 text-none
                      font-weight-medium
                      px-2 px-lg-3
                      py-5
                      mx-md-2
                      nav-link
                    "
                    active-class="nav-link-active"
                    tile
                    depressed
                    text
                  >
                    {{ text }}
                    <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                  </v-btn>
                </template>
                <v-list tile>
                  <v-list-item
                    v-for="(item, keyDropdown) in dropdown"
                    :key="keyDropdown"
                    :to="item.to"
                  >
                    <v-list-item-title class="grey--text text--darken-3">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </div>
    </v-sheet>
  </v-app-bar>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
};
</script>

<style lang="scss" scoped>
.header-app-bar::v-deep {
  .v-toolbar__content {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
  }
}

.header-app-bar {
  .header {
    &:before {
      background: rgba(0, 34, 101, 0.2);
      bottom: 0;
      content: "";
      height: 1px;
      left: 0;
      pointer-events: none;
      position: absolute;
      right: 0;
    }

    .nav-link {
      &:before {
        opacity: 0 !important;
      }

      &.nav-link-active {
        &:after {
          background-color: var(--v-primary-base);
          bottom: -16px;
          content: "";
          height: 2px;
          left: 0;
          position: absolute;
          right: 0;
        }
      }
    }
  }

  &.home {
    .header {
      &:before {
        background: rgba(255, 255, 255, 0.2);
      }

      .nav-link {
        &.nav-link-active {
          &:after {
            background-color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
